module.exports = __webpack_public_path__ + "media/images/favicon-high-res-1bf33c83a7a728150a0f22f54830efc9.png";